import windowScrollStore from "./window-scroll";

const store = () => {
    windowScrollStore();
}

export default store;
